(function () {
  var root = document.getElementById('thl-careers');
  if (!root) return;
  var API = root.getAttribute('data-endpoint') || '';
  var form = document.getElementById('tc-form');
  var pages = [].slice.call(form.querySelectorAll('.tc-page'));
  var bars = [].slice.call(form.querySelectorAll('.tc-steps i'));
  var nextBtn = document.getElementById('tc-next'), backBtn = document.getElementById('tc-back');
  var alertBox = document.getElementById('tc-alert'), savedEl = document.getElementById('tc-saved');
  var step = 1, token = '', appId = '', timer = null, busy = false, lastSent = '';
  var KEY = 'thl-careers-v1';

  function store(o) { try { sessionStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  function load() { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }

  function post(body, keepalive) {
    if (!API) return Promise.reject(new Error('Applications open soon. Please check back shortly.'));
    return fetch(API, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(body), keepalive: !!keepalive, redirect: 'follow' })
      .then(function (r) { return r.json(); });
  }

  function getToken() {
    if (token) return Promise.resolve(token);
    return post({ action: 'start' }).then(function (r) { if (r && r.ok) { token = r.token; persist(); } return token; });
  }

  function values() {
    var v = {};
    [].forEach.call(form.elements, function (el) {
      if (!el.name || el.name === 'website_url' || el.type === 'file') return;
      if (el.type === 'checkbox' && el.name !== 'agree') { if (el.checked) (v[el.name] = v[el.name] || []).push(el.value); return; }
      if (el.name === 'agree') { v.agree = el.checked; return; }
      if (el.type === 'radio') { if (el.checked) v[el.name] = el.value; return; }
      var t = (el.value || '').trim(); if (t) v[el.name] = t;
    });
    return v;
  }

  function persist() { store({ token: token, id: appId, step: step, v: values() }); }

  function restore() {
    var s = load(); if (!s) return;
    token = s.token || ''; appId = s.id || '';
    var v = s.v || {};
    Object.keys(v).forEach(function (k) {
      var val = v[k];
      [].forEach.call(form.querySelectorAll('[name="' + k + '"]'), function (el) {
        if (el.type === 'checkbox' || el.type === 'radio') el.checked = Array.isArray(val) ? val.indexOf(el.value) > -1 : (el.type === 'checkbox' && k === 'agree' ? !!val : el.value === val);
        else el.value = val;
      });
    });
    if (s.step > 1 && appId) show(Math.min(4, s.step));
  }

  function fieldEl(name) { var el = form.querySelector('[name="' + name + '"]'); return el && el.closest('.tc-field'); }
  function setErr(name, msg) { var f = fieldEl(name); if (!f) return; f.classList.toggle('err', !!msg); var m = f.querySelector('.tc-msg'); if (m) m.textContent = msg || ''; }
  function clearErrs(scope) { [].forEach.call((scope || form).querySelectorAll('.tc-field.err'), function (f) { f.classList.remove('err'); }); alertBox.classList.remove('show'); }
  function showAlert(msg) { alertBox.textContent = msg; alertBox.classList.add('show'); }

  var RULES = {
    1: { firstName: 'Please enter your first name.', lastName: 'Please enter your last name.', email: 'Please enter a valid email.', phone: 'Please enter a 10-digit phone number.', city: 'Please tell us where you live.', position: 'Please choose a position.' },
    2: { licensed: 'Please choose one.', years: 'Please choose one.' },
    3: { clientele: 'Please choose one.', comp: 'Please choose one.', days: 'Pick at least one day.' },
    4: { why: 'Please write at least a couple of sentences (40+ characters).', agree: 'Please check this box to continue.' }
  };
  function validate(n) {
    var v = values(), bad = null, r = RULES[n];
    clearErrs(pages[n - 1]);
    Object.keys(r).forEach(function (k) {
      var ok = !!v[k];
      if (k === 'email') ok = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v.email || '');
      if (k === 'phone') { var d = (v.phone || '').replace(/\D/g, ''); if (d.length === 11 && d[0] === '1') d = d.slice(1); ok = d.length === 10; }
      if (k === 'why') ok = (v.why || '').length >= 40;
      if (k === 'agree') ok = v.agree === true;
      if (!ok) { setErr(k, r[k]); if (!bad) bad = k; }
    });
    if (bad) { var el = form.querySelector('[name="' + bad + '"]'); if (el && el.focus) el.focus({ preventScroll: true }); var f = fieldEl(bad); if (f) f.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    return !bad;
  }

  function show(n) {
    step = n;
    pages.forEach(function (p, i) { p.classList.toggle('active', i === n - 1); });
    bars.forEach(function (b, i) { b.classList.toggle('on', i < n); });
    document.getElementById('tc-stepname').textContent = 'Step ' + n + ' of 4 · ' + pages[n - 1].getAttribute('data-name');
    backBtn.hidden = n === 1;
    nextBtn.textContent = n === 4 ? 'Submit application' : 'Next';
    persist();
  }

  function flashSaved() { savedEl.classList.add('show'); clearTimeout(savedEl._t); savedEl._t = setTimeout(function () { savedEl.classList.remove('show'); }, 1800); }

  function canCreate(v) {
    var d = (v.phone || '').replace(/\D/g, '');
    return v.firstName && v.lastName && /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v.email || '') && (d.length === 10 || d.length === 11);
  }

  function save(opts) {
    opts = opts || {};
    var v = values();
    if (!appId && !canCreate(v)) return Promise.resolve({ ok: true, skipped: true });
    var body = { action: 'save', id: appId, page: step, fields: v, website_url: form.website_url.value };
    if (opts.file) body.file = opts.file;
    if (opts.submit) body.submit = true;
    var sig = JSON.stringify(body);
    if (!opts.file && !opts.submit && !opts.force && sig === lastSent) return Promise.resolve({ ok: true, same: true });
    return getToken().then(function (t) {
      body.token = t;
      return post(body, opts.keepalive);
    }).then(function (r) {
      if (r && r.id && r.id !== 'x') appId = r.id;
      if (r && r.ok) { lastSent = sig; flashSaved(); persist(); }
      return r || { ok: false, error: 'Please try again.' };
    });
  }

  function autosave() { clearTimeout(timer); timer = setTimeout(function () { save().catch(function () {}); }, 2200); }

  form.addEventListener('input', function (e) { if (e.target.closest('.tc-field')) e.target.closest('.tc-field').classList.remove('err'); persist(); autosave(); });
  form.addEventListener('change', function (e) {
    if (e.target.name === 'specialties') document.getElementById('tc-ext-wrap').hidden = !form.querySelector('input[name="specialties"][value="Extensions"]:checked');
    persist(); autosave();
  });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden' && appId) { clearTimeout(timer); save({ keepalive: true }).catch(function () {}); } });

  var why = document.getElementById('tc-why'), whyCount = document.getElementById('tc-why-count');
  function countWhy() { var n = why.value.trim().length; whyCount.textContent = n < 40 ? (40 - n) + ' more characters' : ''; }
  why.addEventListener('input', countWhy);

  nextBtn.addEventListener('click', function () {
    if (busy) return;
    if (!validate(step)) return;
    busy = true; nextBtn.disabled = true; var label = nextBtn.textContent; nextBtn.textContent = 'Saving...';
    clearTimeout(timer);
    save({ submit: step === 4, force: true }).then(function (r) {
      if (!r.ok) { if (r.field) setErr(r.field, r.error); showAlert(r.error || 'Something went wrong. Please try again.'); return; }
      if (step === 4) {
        form.style.display = 'none'; document.getElementById('tc-done').classList.add('show');
        try { sessionStorage.removeItem(KEY); } catch (e) {}
        root.scrollIntoView({ behavior: 'smooth' });
      } else { show(step + 1); form.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }).catch(function (err) { showAlert((err && err.message) || 'Connection problem. Please check your internet and try again.'); })
      .then(function () { busy = false; nextBtn.disabled = false; if (nextBtn.textContent === 'Saving...') nextBtn.textContent = label; });
  });
  backBtn.addEventListener('click', function () { clearErrs(); if (step > 1) show(step - 1); });

  // Resume: checked here first, then again (more strictly) on the server
  var fileIn = document.getElementById('tc-resume'), fileState = document.getElementById('tc-filestate');
  fileIn.addEventListener('change', function () {
    var f = fileIn.files && fileIn.files[0]; setErr('resume', '');
    fileState.textContent = '';
    if (!f) return;
    var ext = (f.name.split('.').pop() || '').toLowerCase();
    if (['pdf', 'docx'].indexOf(ext) === -1) { fileState.textContent = ''; showFileErr('Please upload a PDF or Word (.docx) file.'); return; }
    if (f.size > 5 * 1024 * 1024) { showFileErr('That file is over 5 MB. Please upload a smaller version.'); return; }
    var rd = new FileReader();
    rd.onerror = showReadErr;
    rd.onload = function () {
      var u8 = new Uint8Array(rd.result);
      var isPdf = u8[0] === 0x25 && u8[1] === 0x50 && u8[2] === 0x44 && u8[3] === 0x46, isZip = u8[0] === 0x50 && u8[1] === 0x4b;
      if ((ext === 'pdf' && !isPdf) || (ext === 'docx' && !isZip)) { showFileErr("That file doesn't look like a real " + (ext === 'pdf' ? 'PDF' : 'Word document') + '.'); return; }
      if (!appId) { showFileErr('Please complete step 1 first.'); return; }
      fileState.textContent = 'Uploading ' + f.name + '...';
      var b = new FileReader();
      b.onerror = showReadErr;
      b.onload = function () {
        save({ file: { name: f.name, data: String(b.result) }, force: true }).then(function (r) {
          if (r.ok) fileState.textContent = '✓ ' + f.name + ' uploaded';
          else { fileState.textContent = ''; showFileErr(r.error); fileIn.value = ''; }
        }).catch(function () { fileState.textContent = ''; showFileErr("That didn't upload. Please try again - or email it to TheHairLoungeAZ@gmail.com and we'll add it for you."); });
      };
      b.readAsDataURL(f);
    };
    rd.readAsArrayBuffer(f.slice(0, 8));
  });
  function showFileErr(m) { var fld = document.getElementById('tc-resume-field'); fld.classList.add('err'); fld.querySelector('.tc-msg').textContent = m; fileIn.value = ''; }

  // A file the browser cannot read at all. Common on iPhones when the file is in
  // iCloud and hasn't been downloaded to the device. Without this the picker failed
  // silently and the applicant had no idea anything had gone wrong.
  function showReadErr() {
    fileState.textContent = '';
    showFileErr("We couldn't read that file on this device. If it's stored in iCloud or Google Drive, download it first and try again - or just email it to TheHairLoungeAZ@gmail.com and we'll add it to your application for you.");
  }

  restore(); countWhy();
  document.getElementById('tc-ext-wrap').hidden = !form.querySelector('input[name="specialties"][value="Extensions"]:checked');
  if (API) getToken().catch(function () {});
})();
